import { useCanAdministerAIAgents } from "~/pages/manifold-nextgen/hooks/useCanAdministerAIAgents";
import { useCanManageAIAgents } from "~/pages/manifold-nextgen/hooks/useCanManageAIAgents";
import { Agent } from "~/services/agents";

// Duplicating creates a new agent the caller owns, so it sits at the manager tier
// alongside create: `manage:agents` plus the `can_duplicate` grant, which every
// access level confers — including a SYSTEM agent's `user:*` baseline. Distinct
// from deleting (`can_delete`), which only owners hold. An `admin:agents` caller can
// duplicate any visible agent via the FGA bypass, even one it holds no direct
// grant on (`access_level` null).
export const useCanDuplicateAgent = (agent: Agent | undefined): boolean => {
  const isAdmin = useCanAdministerAIAgents();
  const canManage = useCanManageAIAgents();
  return !!agent && ((canManage && agent.access_level !== null) || isAdmin);
};
